// 付款申请单-主页
<template>
  <div id="containt" style="height: 100%!important;">
    <el-tabs v-model="activeName" class="tab-box" @tab-click="handleClick">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit"  :_dataId.sync="dataId" :type="type" :settleId="settleId"
                  :parent-target="_self"
                  @reload="$reloadHandle" @editViewDataUpdate="editViewDataUpdate" @changeTab="changeTab"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div>
          <vxe-grid :stripe="true" border="default" show-overflow :row-config="{ isHover: true }"
                    ref="table-m1" v-bind="vxeOption"
                    :checkbox-config="{ labelField: '', highlight: true, reserve: true, range: true }"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange"
                    @custom="$vxeTableUtil.customHandle">

            <template #form>
              <div class="clearfix screen-btns" style=" border-bottom: 1px solid #ededed !important;">
                <div class="fl">
                  <vxe-button  status="primary" class="button-sty" icon="el-icon-plus" v-if="isSite"
                              @click="openEditDialog(0, 'edit')">新增
                  </vxe-button>

                  <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"

                              @click="doExcle">批量导出
                  </vxe-button>
                </div>
                <!-- <div class="fr" style="display: flex;" v-if="checkButton"> -->
                <div class="fr" style="display: flex;position: relative;">

<!--                  <el-input  type="textarea" :autosize="{ minRows: 1, maxRows: 3}" placeholder="请输入"style="width: 200px;     height: 27px !important; "-->
<!--                            v-model="formData.searchValue" @keyup.enter.native="searchEvent" clearable>-->
<!--                    &lt;!&ndash; <i slot="prefix" class="el-input__icon el-icon-search"></i> &ndash;&gt;-->
<!--                  </el-input>-->
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 10px;" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                  <vxe-button status="warning" icon="el-icon-brush" style="margin: 0 0 0 10px;" class="button-sty"
                              @click="clearEvent">一键清空
                  </vxe-button>
                  <!-- <el-button @click="show3 = !show3">Click Me</el-button> -->
                  <div style="display: flex;margin-top: 5px;margin-right: 5px;color: #409eff;" @click="show3 = !show3">
                    <svg t="1682558973727" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="1587" width="16" height="16">
                      <path
                        d="M921.6 686.08h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m0-122.88h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m-166.4-289.28c-2.56 2.56-243.2 227.84-243.2 227.84v389.12l-163.84-81.92v-307.2L112.64 281.6c-2.56-2.56-5.12-5.12-7.68-5.12-15.36-15.36-23.04-35.84-23.04-58.88 0-46.08 38.4-84.48 84.48-84.48h527.36c46.08 0 84.48 38.4 84.48 84.48 0 23.04-10.24 43.52-23.04 56.32zM693.76 179.2H166.4C145.92 179.2 128 197.12 128 217.6c0 10.24 2.56 20.48 10.24 25.6l2.56 2.56 227.84 215.04 15.36 12.8 2.56 25.6-2.56 273.92 81.92 40.96V473.6l15.36-12.8 230.4-212.48 2.56-2.56c7.68-7.68 10.24-15.36 10.24-25.6 7.68-23.04-10.24-40.96-30.72-40.96z m-17.92 588.8H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48h-245.76c-10.24 0-20.48-10.24-20.48-20.48 0-12.8 7.68-20.48 20.48-20.48z"
                        fill="#0ea2f0" p-id="1588"></path>
                    </svg>
                    <span>更多筛选</span>
                  </div>
                </div>
              </div>

              <el-collapse-transition name="fade">
                <vxe-form v-show="show3" ref="form" class="screen-box" title-width="92px"
                          title-align="right" :data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                <vxe-form-item title="状态:" field="name">
                  <template v-slot>
                    <el-select v-model="formData.stat"  style="width:9vw;" clearable>
                      <el-option :value="1" label="制单"></el-option>
                      <el-option :value="2" label="驳回"></el-option>
                      <el-option :value="3" label="审批中"></el-option>
                      <el-option :value="5" label="已审批"></el-option>
                      <el-option :value="6" label="已提交付"></el-option>
                      <el-option :value="9" label="已付款"></el-option>
                      <el-option :value="99" label="取消"></el-option>
                    </el-select>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="结算单号:" field="name">
                  <template v-slot>
                    <el-input v-model="formData.settleNo" style="width:9vw;" clearable>
                    </el-input>
                  </template>
                </vxe-form-item>

                  <vxe-form-item title="服务中心:" field="name">
                    <template v-slot>
                      <org-search :org-name.sync="formData.orgName" style="width:9vw;"
                                  :org-id-path.sync="formData.orgIdPath"
                                  :show="!currentIsSite"
                                  :org-id.sync="formData.orgId"/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="服务商:" field="name">
                    <template v-slot>
                      <site-pop-search :site-id.sync="formData.siteId"
                                       :site-name.sync="formData.siteName"
                                       :org-id.sync="formData.orgId"
                                       :org-id-path.sync="formData.orgIdPath"
                                       :org-name.sync="formData.orgName"
                                       :editable="!currentIsSite"
                                       style="width:9vw;"
                      />
                    </template>
                  </vxe-form-item>


                  <vxe-form-item title="创建时间:" field="name">
                    <template v-slot>
                      <el-date-picker style="width:17vw;" v-model="formData.createDate" type="daterange" align="right" unlink-panels
                                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="发票号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.invoiceNo" style="width:9vw;" clearable>
                      </el-input>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="付款单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.payNo" style="width:9vw;" clearable>
                      </el-input>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="结算月份:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.settleMonth" style="width:9vw;" clearable>
                      </el-input>
                    </template>
                  </vxe-form-item>

                </vxe-form>
              </el-collapse-transition>


              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
											btnGoodsStatusBtn1: goodsStatusIndex == index,
											btnGoodsStatusBtn: goodsStatusIndex != index
										}" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span v-if="item.name != '所有'" class="num_color">{{ item.num }}</span>
                  </div>
                </div>
              </div>

            </template>

            <template #option="{row}">
              <div>
                <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row, 'edit')">
                  <el-tooltip :enterable=false effect="dark" content="编辑" placement="top"
                              popper-class="tooltip-skin">
                    <i class="el-icon-edit"/>
                  </el-tooltip>
                </a>

                <el-dropdown @command="handleCommand($event, row)" >
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">

                    <el-dropdown-item v-if="!isSite && row.stat == 3 && settleApplyReject" command="驳回">驳回</el-dropdown-item>
                    <el-dropdown-item v-if="!isSite && row.stat ==3 && settleApplyCheck" command="审核">审核</el-dropdown-item>
                    <el-dropdown-item v-if="!isSite && row.stat == 5 && settleApplycommitPay" command="提交付款">提交付款</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
    <rejectDialog v-if="showRejectDialog"  :visiable.sync="showRejectDialog"
                  :multi="true" @commit="invoiceCommit"  :id="applyId" @goBackIndex="goBackIndex"/>


  </div>
</template>

<script>
import editView from './edit.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import request from "@/router/axios";
import checkboxButton from "element-ui/packages/checkbox-button";
import api from "@/api/projectApi";
import store from "@/store";
import detailsDialog from "@/views/dialogCommon/detailsDialog.vue";
import OrgSearch from "@/components/formItem/orgSearch.vue";
import SiteSearch from "@/components/formItem/siteSearch.vue";
import SitePopSearch from "@/components/formItem/sitePopSearch.vue";
import ExcelUpload from "@/components/upload/excel.vue";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
// 图片 文档 上传组件
import PhotoUpload from "@/components/formItem/photoUpload.vue"
import textUpload from "@/components/formItem/textUpload.vue"
import {indexPageMixins, siteMixins} from "@/mixins/tabChang";
import rejectDialog from "@/views/finance/settleApply/rejectDialog.vue";


export default {
  name: 'settleApply',

  inject: ['reload'],
  mixins: [indexPageMixins, siteMixins],
  components:
    {
      rejectDialog,
       PhotoUpload,
    textUpload,
      ExcelUpload,
      SitePopSearch, SiteSearch, OrgSearch, editView, pager,  detailsDialog},
  data() {
    return {
      settleId:null,
      isSecondAnswer: null,
      snUserId: null,
      settleApplyReject:false,
      settleApplyCheck:false,
      settleApplycommitPay:false,
      settleApplySave:false,
      settleApplySaveAndSubmit:false,
      applyId:null,
      showRejectDialog:false,

      dialogVisible: false,
      row1: '',
      showDetailsDialog: false,
      loading: false,
      actPicUrl: "",
      showPicDialog: false,
      type: null, // 打开常规页面类型
      drawer: false,
      total: 0,
      checkBillId: null,
      confirmNo: null,
      formLabelWidth: '80px',
      checkSubjectOption: [],
      initiateAppeal: false,
      isSite: null,
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        stat: null,
        siteId: null,
        searchValueIsEnable: false,

        tabStat:'',
        userMobile: '', // 用户号码
        siteName: '',  // 网点名称,冗余字段
        settleNo:'',
        createTimeBegin: '',
        createTimeEnd: '',
        searchValue: '',
        orgId: null,
        orgName: null,
        orgIdPath: null,
        invoiceNo: null,
        payNo: null,
        createDate:null,
      },
      formData: {
        tabStat: '',
        userMobile: '', // 用户号码
        stat: '',  // 状态：1制单；2.待确认；3待申诉；5已申诉；7执行考核；9已结算；19取消执行；99关闭
        siteName: '',  // 网点名称,冗余字段
        siteId: '',
        settleNo:'',
        createTimeBegin: '',
        createTimeEnd: '',
        searchValue: '',
        orgId: null,
        orgName: null,
        orgIdPath: null,
        invoiceNo: null,
        payNo: null,
        createDate:null
      },
      form2: {
        appealRemark: '',
        siteAnswerNote: '',
      },

      editViewDataUpdateFlag: false,
      showSelectStat: false,


      goodsStatusList: [],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个
      show3: false,

      showCloseDialog: false,
      showConfirmDialog: false,
      showAuditDialog: false,

      showPreconditionDialog: false,
      showPreconditionDialog2: false,


      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      value2: '',
      value3: '',
      value: '',
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      fileList: [],


      pageSizes: [10, 20, 100],
      columns: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        {width: 100, field: 'stat', fixed: 'right', title: '操作', showOverflow: true, slots: {default: 'option'}},
        {
          title: '付款申请单号', field: 'applyNo', width: 190, slots: {
            default: ({row}) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.showInfo(row, $event)}>{row.applyNo}</span>
              ]
            }
          }
        },
        {
          title: '结算单号', field: 'settleNo', width: 190
        },
        {
          title: '结算月份', field: 'settleMonth', width: 190
        },
        {
          title: '状态', field: 'stat', width: 125, slots: {
            default: ({row}) => {
              if (row.stat == 1) {
                return [
                  <div class="txt-status">
                    <span>制单</span>
                  </div>
                ];
              } else if (row.stat == 2) {
                return [
                  <div class="txt-status disable">
                    <span>驳回</span>
                  </div>
                ];
              } else if (row.stat == 3) {
                return [
                  <div class="txt-status neutral">
                    <span>审批中</span>
                  </div>
                ];
              } else if (row.stat == 5) {
                return [
                  <div class="txt-status">
                    <span>已审批</span>
                  </div>
                ];
              } else if (row.stat == 6) {
                return [
                  <div class="txt-status">
                    <span>已提交付</span>
                  </div>
                ];
              } else if (row.stat == 9) {
                return [
                  <div class="txt-status">
                    <span>已付款</span>
                  </div>
                ];
              }  else if (row.stat == 99) {
                return [
                  <div class="txt-status disable">
                    <span>取消</span>
                  </div>
                ];
              }
            }
          }
        },
        {title: '服务中心', field: 'orgName', width: 100,},
        {title: '服务商帐号', field: 'siteCode', width: 130,},
        {title: '服务商', field: 'siteName', width: 130,},
        {
          title: '扣税方式', field: 'taxType', width: 125, slots: {
            default: ({row}) => {
              if (row.taxType == 1) {
                return [
                  <div class="txt-status">
                    <span>票前扣税</span>
                  </div>
                ];
              } else if (row.taxType == 2) {
                return [
                  <div class="txt-status">
                    <span>票后扣税</span>
                  </div>
                ];
              }
            }
          }
        },
        {title: '对接单号', field: 'sendNo', width: 160,},
        {title: '付款申请单备注', field: 'applyRemark', width: 160,},
        {title: '创建人', field: 'createBy', width: 100,},
        {title: '创建时间', field: 'createTime', width: 100,},
      ]
    };
  },
  watch: {
    'formData.createDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        }else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },

    'formData.siteAnswerDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.siteAnswerDateBegin = newVal[0]
          this.formData.siteAnswerDateEnd = newVal[1]
        }else if (newVal == null) {
          this.formData.siteAnswerDateBegin = null
          this.formData.siteAnswerDateEnd = null
        }
      },
      deep: true,
    },
    'formData.checkDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.checkDateBegin = newVal[0]
          this.formData.checkDateEnd = newVal[1]
        }else if (newVal == null) {
          this.formData.checkDateBegin = null
          this.formData.checkDateEnd = null
        }
      },
      deep: true,
    },
    showPreconditionDialog(newVal) {
      if (!newVal) {
        this.reload()
      }
    },
    editViewDataUpdateFlag(n) {
      if (n) {
        this.editViewDataUpdateFlag = false
        this.flushed()
      }
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.flushed()
      }
    },
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },

  computed: {
    checkboxButton() {
      return checkboxButton
    },
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    },
    ...mapGetters(["permissions"]),

  },
  created() {
    const userInfo = store.getters.userInfo;
    if (userInfo.snUserId) {
      this.isSite = true;
      this.snUserId = userInfo.snUserId
    }
    this.siteInit()
    this.settleId=this.$route.query.settleId
    console.log("this.settleId----------",this.settleId)
    if (this.settleId){
      this.dataId = 0;

      this.activeName = 'first';
      this.$openEditView('showEdit');
    }
    this.settleApplyReject = this.permissions["settleApplyReject"];
    this.settleApplyCheck = this.permissions["settleApplyCheck"];
    this.settleApplycommitPay = this.permissions["settleApplycommitPay"];
    this.settleApplySave = this.permissions["settleApplySave"];
    this.settleApplySaveAndSubmit = this.permissions["settleApplySaveAndSubmit"];
  },
  mounted() {
    this.loadGoodsStatusList(true)
    this.initDate()
  },
  methods: {
    setSiteData() {
      this.formData.siteId = this.currentSiteData.id
      this.formData.siteName = this.currentSiteData.userName
      this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
      this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
      this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath

    },

    toFilterData() {
            this.searchEvent();
     },
    handleClick(tab, ) {
        // console.log(tab.index,"选中的标签");
        if(tab.index==1){
          //用于审核后停留在当前筛选页面 刷新列表页面
          this.searchEvent()
        }
      },
    //导出
    doExcle(){
      // const  result =
      this.$mask.open()
      doCheckExcle(fileNames.sfSettleApply).then(response => {
        if (response.data.msg=="success"){
          doDownLoadExcle(api.sfSettleApply.getExportUrl, this.formData).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          }).catch(() => {
            this.$mask.close()
          })
        }else{
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },

    closeD2(v) {
      // this.reload()
      console.log(v, "v的值");
      this.showDetailsDialog = v

    },

    // 切换tab到列表页
    changeTab() {
      this.activeName = 'second';
      this.showEdit = false
      this.settleId = null
      this.flushed()
    },

    // 显示详情
    showInfo(row, $event) {
      console.log(row, "rr");
      this.openEditDialog(row, 'info')
    },

    //抽屉关闭后改变父组件的visible的值
    closeD(v) {
      this.showConfirmDialog = false
      this.showCloseDialog = false
      this.showAuditDialog = false
      // this.flushed()
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.requestParam.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: {userName: queryStr}
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.userName, id: item.id})
        })
        callback(temp)
      })
    },


    // 设置搜索时间条件默认一个月内
    initDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
      start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.createDate = [start, end]
          //  console.log(this.formData.date,"1212");

      this.requestParam.createTimeBegin = start
      this.requestParam.createTimeEnd = end
    },

    // 加载tab数据
    loadGoodsStatusList(init) {
      this.$objCopy(this.formData, this.requestParam)
      this.$http({
        url: api.sfSettleApply.getCount,
        method: 'post',
        data: this.requestParam
      }).then(res => {
        this.goodsStatusList = res.data.data
        if (init) {
          if (this.goodsStatusList) {
            let index = this.goodsStatusList.length - 1;
            this.requestParam.stat = null
            this.formData.stat = null
            this.goodsStatusIndex = index
          }
        }
      })
    },


    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
      this.loadGoodsStatusList(false)

    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true
    },

    cancelForm() {
      this.loading = false;
      this.initiateAppeal = false;
      clearTimeout(this.timer);
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比

      this.showSelectStat = (this.goodsStatusItem === '所有')
      this.requestParam.tabStat = item.name
      this.formData.tabStat = this.requestParam.tabStat

      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.sfSettleApply.getListPageUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.requestParam.searchValueIsEnable = false
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    clearEvent(){
      this.formData.stat=null
      this.formData.settleNo=''
      if(!this.isSite) {
        this.formData.siteId = null
        this.formData.siteName = ''

        this.formData.orgName = ''
        this.formData.orgId = null
        this.formData.orgIdPath = ''
      }
      if(this.formData.createDate){
        this.formData.createDate=null
        this.formData.createTimeBegin=null
        this.formData.createTimeEnd=null
      }
      this.formData.invoiceNo=''
      this.formData.payNo=''
      this.formData.settleMonth=''

      this.formData.searchValue=null
    },






    // 菜单选中
    handleCommand(command, row) {
      console.log(command, row, 'command')
      this.applyId = row.id
      if (command == '驳回') {  // 确认操作
        this.rejectApply()
      } else if (command == '审核') {  // 确认操作
        this.checkApply()
      } else if (command == '提交付款') {  // 确认操作
        this.commitPayApply()
      }

    },
    checkApply(){
      this.$baseConfirm('您确定要审核吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: api.sfSettleApply.checkApplyUrl,
          method: 'post',
          data: {id:this.applyId}
        }).then(res => {
          this.$mask.close()
          if(res.data.type == "success"){
            this.$message.success('操作成功')
            this.flushed()
          }else{
            this.$message.error(res.data.message)
          }
        }).catch(e => {
          this.$mask.close()

        })
      })
    },
    commitPayApply(){
      this.$baseConfirm('您确定要提交付款吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: api.sfSettleApply.commitPayApplyUrl,
          method: 'post',
          data: {id:this.applyId}
        }).then(res => {
          this.$mask.close()
          if(res.data.type == "success"){
            this.$message.success('操作成功')
            this.flushed()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    rejectApply(){
      this.showRejectDialog = true
    },
    goBackIndex(){
      this.showRejectDialog = false;
      this.getData();
    },

    handleCommand2(command, b) {
      if (b == 1) {
        this.showPreconditionDialog2 = true;
      } else if (b == 2) {
        this.open()
      }
    },

    optionChange(value, target) {
      console.log('接受的option的值1', target)
      if (target == 2) {

        this.open()


      }


    },




    gradeChange() {
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },

    // 新增
    openEditDialog(row, type) {
      this.type = type
      this.dataId = !row.id || typeof row.id == 'object' ? 0 : row.id;

      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },

  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBtn {
  //白底按钮

  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

.btnGoodsStatusBtn1 {
  //红底按钮

  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

//.el-drawer.ltr, .el-drawer.rtl {
//  height: 100%;
//  top: 0;
//  bottom: 0;
//  background-color: #cbcbcb;
//}
.avue-view {
  height: 100%;

  overflow: scroll !important;;
}
</style>
